var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 1.21875L12 4.71875C12.3125 5.03125 12.3125 5.5 12 5.78125C11.7188 6.09375 11.25 6.09375 10.9375 5.78125L8.71875 3.5625V11.25C8.71875 11.6875 8.40625 12 7.96875 12C7.5625 12 7.21875 11.6875 7.21875 11.25V3.5625L5 5.78125C4.71875 6.09375 4.25 6.09375 3.96875 5.78125C3.65625 5.5 3.65625 5.03125 3.96875 4.71875L7.46875 1.21875C7.75 0.9375 8.21875 0.9375 8.53125 1.21875ZM2.25 2H2.5C2.90625 2 3.25 2.34375 3.25 2.75C3.25 3.1875 2.90625 3.5 2.5 3.5H2.25C1.8125 3.5 1.5 3.84375 1.5 4.25V14.75C1.5 15.1875 1.8125 15.5 2.25 15.5H13.75C14.1562 15.5 14.5 15.1875 14.5 14.75V4.25C14.5 3.84375 14.1562 3.5 13.75 3.5H13.5C13.0625 3.5 12.75 3.1875 12.75 2.75C12.75 2.34375 13.0625 2 13.5 2H13.75C14.9688 2 16 3.03125 16 4.25V14.75C16 16 14.9688 17 13.75 17H2.25C1 17 0 16 0 14.75V4.25C0 3.03125 1 2 2.25 2Z",
    fill: "#00A6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0bf63643c4de0035298cccf7019fba19.svg";
export { ForwardRef as ReactComponent };